<template>
  <div class="travel-table ut-d-flex">
    <div class="flex-item ut-d-flex ut-f-wrap">
      <div class="flex-item">
        <span class="heading">{{ $t("passanger") }}</span>
        <ExpandableLines :items="item.contacts.map(getName)"/>
        <!-- <div class="content ut-fc">
          <div
            v-for="contact in item.contacts"
            :key="contact.contact_id"
            class="name"
          >
            {{ getName(contact) }}
          </div>
        </div> -->
      </div>
      <div class="flex-item">
        <span class="heading">{{ $t("carrier") }}</span>
        <div class="content">{{ item.carrier }}</div>
      </div>
      <div class="flex-item">
        <span class="heading">{{ $t("travel_c") }}</span>
        <div class="content">{{ item.travel_no }}</div>
      </div>
      <!-- <div class="flex-item">
        <span class="heading">{{ $t("tab_title_costs") }}</span>
        <div class="content">{{ item.costs }}</div>
      </div> -->
    </div>
    <div class="flex-item confirmed-item">
      <span class="heading">{{ $t("confirmed") }}</span>
      <div class="content ut-mt-4px">
        <div
          class="dt-checkbox v2 s1"
          title="Confirm Travel"
          :class="{
            disabled: true,
          }"
        >
          <input
            type="checkbox"
            name="checkbox"
            id="checkbox"
            :checked="item['confirmed_flag'] == 1 ? true : false"
            @click.stop=""
            :disabled="true"
          />
          <div class="checkmark"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContactFuncs } from "../../../modules/contacts/models/contacts.model";
import ExpandableLines from "../../../plugins/expandable/expandable-lines.vue";

export default {
  components: {
    ExpandableLines,
  },
  props: ["item"],
  methods: {
    getName: ContactFuncs.getName,
  },
};
</script>

<style lang="scss">
.travel-table {
  color: #828282;
  margin-bottom: 10px;
  .flex-item {
    flex: 1;
    &.confirmed-item {
      flex: 0 1 52px;
      max-width: 51px;
      .dt-checkbox {
        margin: 0;
      }
    }
    > .flex-item {
      flex: 1 0 50%;
      /* margin-bottom: 10px; */

      div.content {
        /* height: 24px; */
        min-height: 24px;
      }
    }
  }

  .heading {
    font-size: 11px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    > .flex-item {
      &:first-child {
        flex-direction: column;
      }
    }
  }
}
</style>